import { Component, Input  } from '@angular/core';
import { Platform, NavController, NavParams, ModalController } from 'ionic-angular';
import { WildlifeService } from '../../providers/wildlife-service';
import { GoogleAnalytics } from '@ionic-native/google-analytics';
import { SocialSharing } from '@ionic-native/social-sharing';

@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})

export class HomePage {

@Input() autoplay;
@Input() effect;
@Input() speed;
@Input() pager;
@Input() initialSlide;
@Input() loop;
@Input() paginationType; 
@Input() slidesPerView;  

constructor( 
public platform: Platform,
public nav: NavController, 
public navParams: NavParams, 
public modalCtrl: ModalController,
public wildlifeService: WildlifeService,
private socialSharing: SocialSharing,
private ga: GoogleAnalytics) {   
    this.platform.ready().then(() => {
      ga.trackView("Home Page"); //NOT SURE WHY NOT WORKING SAYS PLUG IN NOT LOADED.THINK SOLVED
        }); 
  }
 
 ionViewDidLoad(){
  console.log('Home View Loaded');
     /*
     this.wildlifeService.fetchWildlife('classis','Aves');
     this.wildlifeService.fetchWildlife('classis','Mammalia'); 
     this.wildlifeService.fetchWildlife('classis','Amphibia'); 
     this.wildlifeService.fetchWildlife('classis','Reptilia'); 
     this.wildlifeService.fetchWildlife('classis','Insecta'); 
     this.wildlifeService.fetchWildlife('regnum' ,'Plantae');
    */
     }

  openModalContact() {
    let contactModal = this.modalCtrl.create('ContactUs');
        contactModal.present();
  }

 openPageWildlifeTest() {
  //console.log("Going to Experience Us" + 'pageName');
      this.nav.push('WildlifeBirdsPage');
  }

  openPageMammals() {
  //console.log("Going to Experience Us" + 'pageName');
      this.nav.push('WildlifeMammalsPage');
  }

  openPageReptiles() {
  //console.log("Going to Experience Us" + 'pageName');
      this.nav.push('WildlifeReptilesPage');
  }
    
  openPageExperienceUs() {
  //console.log("Going to Experience Us" + 'pageName');
      this.nav.push('ExperienceUs');
  }
  
  openPageAboutUs() {
 //   console.log("Going to About Us");
    this.nav.push('AboutUs');  
  }
  
  openPageJoinUs() {
//    console.log("Going to Join Us");
    this.nav.push('JoinUs');  
  }
  
  openPageOurWildlife() {
 //   console.log("Going to Our Wildlife");
    this.nav.push('OurWildlife');  
  }
  
  openPageContactUs() {
 //   console.log("Going to Contact Us");
    this.nav.push('ContactUs');  
  }

  regularShare(){
    // share(message, subject, file, url)
    this.socialSharing.share("Testing, sharing this from inside an app I'm building right now", "Bou Bou Lodge - Test Only", "www/assets/img/bouboulogo.gif", "https://www.bouboulodge.co.za"); 
     }
     twitterShare(){
    this.socialSharing.shareViaTwitter("Testing, sharing this from inside an app I'm building right now", "www/assets/img/bouboulogo.gif", "https://www.bouboulodge.co.za"); 
  }
    facebookShare(){
       this.socialSharing.shareViaFacebookWithPasteMessageHint("Testing, sharing this from inside an app I'm building right now", "Bou Bou Lodge - Test Only", "www/assets/img/bouboulogo.gif", "https://www.bouboulodge.co.za");
    }
  
    whatsappShare(){
      this.socialSharing.shareViaWhatsApp("Testing, sharing this from inside an app I'm building right now", "www/assets/img/bouboulogo.gif", "https://www.bouboulodge.co.za")
    }

    instagramShare(){
    this.socialSharing.shareViaInstagram("Testing, sharing this from inside an app I'm building right now", "www/assets/img/bouboulogo.gif"); 
  }
}

  


// WEBPACK FOOTER //
// ./src/pages/home/home.ts